import axios from 'axios';
import connection from './connection';
import {DeheadingPeelingRequest,DeheadingPeelingResponseModel,AllDeheadingpeelingResponse, DeheadingFilterReq, DeheadingPeelingRequestDto, ScopeGradeReq } from'@gtpl/shared-models/masters';
import { CommonResponse } from '@gtpl/shared-models/production-management';


export class DeheadingPeelingService{
    URL = connection.DEPLOY_URL + '/deheading-peeling-chart';

    
    

    async saveDeheadingPeelingInfo(req:DeheadingPeelingRequestDto): Promise<AllDeheadingpeelingResponse> {
        console.log(req,'ddddddddddd')
        return await axios.post(this.URL + '/saveDeheadingPeelingInfo',req)
            .then(res => {
                console.log(res,'res.data')
                return res.data
            })
    }
    async getDeheadingPeelingInfo(): Promise<AllDeheadingpeelingResponse> {
        return await axios.post(this.URL + '/getDeheadingPeelingInfo')
            .then(res => {
                return res.data
            })
    }
    async getRmCountPriceListInfoCount(): Promise<AllDeheadingpeelingResponse> {
        return await axios.post(this.URL + '/getRmCountPriceListInfoCount')
            .then(res => {
                return res.data
            })
    }
    async getAllPeelingInfo(req: DeheadingFilterReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllPeelingInfo',req)
            .then(res => {
                return res.data
            })
    }
    async getFoodTypes(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getFoodTypes')
            .then(res => {
                return res.data
            })
    }
    async getValueAdd1(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getValueAdd1')
            .then(res => {
                return res.data
            })
    }
    async getValueAdd2(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getValueAdd2')
            .then(res => {
                return res.data
            })
    }

    async getScopeOfWorkDropdown(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getScopeOfWorkDropdown')
            .then(res => {
                return res.data
            })
    }

    async getPellingRateAgainstScopeAndGrade(req:ScopeGradeReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getPellingRateAgainstScopeAndGrade',req)
            .then(res => {
                return res.data
            })
    }
}